var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpotlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "#020002"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.625 23.6522L21.4017 20.4289C22.2632 19.3201 22.6697 17.9246 22.5383 16.5266C22.407 15.1285 21.7478 13.8331 20.6949 12.9041C19.6419 11.9751 18.2745 11.4823 16.871 11.5261C15.4675 11.57 14.1335 12.1471 13.1406 13.14C12.1477 14.1329 11.5705 15.4669 11.5267 16.8704C11.4829 18.2739 11.9757 19.6414 12.9047 20.6943C13.8337 21.7472 15.1291 22.4064 16.5271 22.5378C17.9252 22.6691 19.3207 22.2626 20.4295 21.4011L23.6528 24.6244L24.625 23.6522ZM17.0625 21.1869C16.2467 21.1869 15.4491 20.945 14.7708 20.4917C14.0924 20.0385 13.5637 19.3942 13.2515 18.6405C12.9393 17.8867 12.8576 17.0573 13.0168 16.2572C13.1759 15.457 13.5688 14.722 14.1457 14.1451C14.7226 13.5682 15.4576 13.1753 16.2578 13.0162C17.0579 12.857 17.8873 12.9387 18.6411 13.2509C19.3948 13.5631 20.0391 14.0918 20.4923 14.7702C20.9456 15.4485 21.1875 16.2461 21.1875 17.0619C21.1863 18.1556 20.7513 19.2041 19.978 19.9774C19.2047 20.7507 18.1561 21.1857 17.0625 21.1869Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 12.25H5.375V13.625H10.875V12.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.375 5.375H5.375V6.75H16.375V5.375Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.375 8.8125H5.375V10.1875H16.375V8.8125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotlight);
export default __webpack_public_path__ + "static/media/spotlight.15c281bf68625e350a23c6f7a78b8b8b.svg";
export { ForwardRef as ReactComponent };